<template>
  <section class="install-section">
    <h2 class="page-title" v-html="$t('main.install.title')" />

    <div class="install-block">
      <div class="install-item install-item_1">
        <div class="install-item__num">1</div>
        <div class="install-item__text" v-html="$t('main.install.text1')" />
        <div class="install-item__btns">
          <a
            href="https://t.me/avoVPN_bot"
            target="_blank"
            rel="noopener noreferrer"
            class="btn btn_sm"
          >
            <svg
              width="26"
              height="22"
              viewBox="0 0 26 22"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              class="btn__icon"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M1.78736 9.50233C8.76667 6.46155 13.4206 4.45689 15.7493 3.48834C22.3979 0.722916 23.7795 0.242533 24.68 0.226671C24.878 0.223182 25.3208 0.272264 25.6077 0.505018C25.8499 0.70155 25.9165 0.967037 25.9484 1.15337C25.9803 1.33971 26.02 1.76418 25.9884 2.09585C25.6281 5.8815 24.0692 15.0683 23.276 19.3083C22.9404 21.1024 22.2796 21.7039 21.6399 21.7628C20.2496 21.8907 19.1938 20.844 17.8473 19.9613C15.7401 18.58 14.5498 17.7202 12.5044 16.3724C10.1407 14.8147 11.673 13.9586 13.0201 12.5594C13.3726 12.1933 19.4983 6.62147 19.6169 6.11602C19.6317 6.05281 19.6455 5.81717 19.5055 5.69275C19.3655 5.56832 19.1589 5.61087 19.0098 5.64471C18.7985 5.69268 15.4323 7.91758 8.91132 12.3194C7.95585 12.9755 7.09041 13.2952 6.31501 13.2785C5.46019 13.26 3.81586 12.7951 2.59347 12.3978C1.09416 11.9104 -0.0974649 11.6527 0.00629874 10.825C0.0603452 10.3939 0.654034 9.95302 1.78736 9.50233Z"
                fill="currentColor"
              />
            </svg>

            <div class="btn__text">{{ $t('main.install.btn') }}</div>
          </a>
        </div>
      </div>
      <div class="install-item install-item_2">
        <div class="install-item__num">2</div>
        <div class="install-item__text" v-html="$t('main.install.text2')" />
      </div>
      <div class="install-item install-item_3">
        <div class="install-item__num">3</div>
        <div class="install-item__text" v-html="$t('main.install.text3')" />
        <div class="install-item__btns">
          <a
            href="https://apps.apple.com/app/avovpn-fast-secure-vpn-app/id6670333179"
            target="_blank"
            rel="noopener noreferrer"
            class="btn btn_sm"
          >
            <svg
              width="24"
              height="28"
              viewBox="0 0 24 28"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              class="btn__icon"
            >
              <path
                d="M22.3256 9.54615C22.1624 9.67217 19.2808 11.2879 19.2808 14.8807C19.2808 19.0363 22.9475 20.5065 23.0572 20.5429C23.0403 20.6325 22.4747 22.5563 21.124 24.5165C19.9196 26.2414 18.6617 27.9636 16.7481 27.9636C14.8346 27.9636 14.3421 26.8575 12.1331 26.8575C9.98038 26.8575 9.21497 28 7.46463 28C5.7143 28 4.49301 26.4038 3.0888 24.4436C1.46229 22.1418 0.148132 18.5659 0.148132 15.1719C0.148132 9.72817 3.70508 6.84108 7.20574 6.84108C9.06582 6.84108 10.6164 8.05641 11.7842 8.05641C12.8957 8.05641 14.6292 6.76828 16.7453 6.76828C17.5473 6.76828 20.4289 6.84108 22.3256 9.54615ZM15.7407 4.46365C16.6159 3.43034 17.235 1.9966 17.235 0.562856C17.235 0.364036 17.2181 0.162416 17.1815 0C15.7576 0.0532053 14.0636 0.943695 13.0421 2.12261C12.2401 3.0299 11.4915 4.46365 11.4915 5.91699C11.4915 6.13541 11.5281 6.35384 11.545 6.42384C11.635 6.44064 11.7814 6.46025 11.9277 6.46025C13.2053 6.46025 14.8121 5.60896 15.7407 4.46365Z"
                fill="currentColor"
              />
            </svg>

            <div class="btn__text">iOS</div>
          </a>
          <a
            href="https://play.google.com/store/apps/details?id=com.avo.vpn"
            target="_blank"
            rel="noopener noreferrer"
            class="btn btn_sm"
          >
            <svg 
              width="23" 
              height="26" 
              viewBox="0 0 23 26" 
              fill="none" 
              xmlns="http://www.w3.org/2000/svg"
              class="btn__icon"
            >
              <path 
                d="M22.1925 14.6853L18.0097 16.9958L14.2581 13.3572L18.0396 9.68941L22.1925 11.9832C22.4376 12.1185 22.6415 12.3148 22.7834 12.5522C22.9252 12.7896 23 13.0595 23 13.3343C23 13.6091 22.9252 13.879 22.7834 14.1163C22.6415 14.3537 22.4376 14.5501 22.1925 14.6853ZM0.119538 1.79553C0.0407037 1.98331 0.000101516 2.18428 0 2.38721V24.2803C0 24.5063 0.0480287 24.7167 0.132346 24.9053L12.0381 13.3561L0.119538 1.79553ZM13.1481 12.2801L16.6254 8.90711L2.37476 1.03615C2.06919 0.865136 1.71354 0.799458 1.36508 0.849686L13.1481 12.2801ZM13.1481 14.4332L1.40778 25.822C1.72583 25.8595 2.06097 25.8053 2.37476 25.6313L16.5955 17.7771L13.1481 14.4332Z" 
                fill="currentColor"
              />
            </svg>
            <div class="btn__text">Android</div>
          </a>
        </div>

        <div class="install-item__btns">
          <a
            href="https://github.com/hiddify/hiddify-next/releases/latest/download/Hiddify-Windows-Setup-x64.exe"
            target="_blank"
            rel="noopener noreferrer"
            class="btn btn_sm"
          >
            <svg 
              width="21" 
              height="22" 
              viewBox="0 0 21 22" 
              fill="none" 
              xmlns="http://www.w3.org/2000/svg"
              class="btn__icon"              
            >
              <path 
              d="M0.00116652 3.39217L8.60719 2.20683V10.5217H0L0.00116652 3.39217ZM0.00116652 18.6078L8.60719 19.7943V11.581H0L0.00116652 18.6078ZM9.5533 19.9203L21 21.5V11.581H9.5533V19.9203ZM9.5533 2.07967V10.5217H21V0.5L9.5533 2.07967Z" 
                fill="currentColor"
              />
            </svg>

            <div class="btn__text">Windows</div>
          </a>
          <a
            href="https://apps.apple.com/ru/app/v2box-v2ray-client/id6446814690"
            target="_blank"
            rel="noopener noreferrer"
            class="btn btn_sm"
          >
            <svg 
              width="27" 
              height="24" 
              viewBox="0 0 27 24" 
              fill="none" 
              xmlns="http://www.w3.org/2000/svg"
              class="btn__icon"
            >
              <path 
                fill-rule="evenodd" 
                clip-rule="evenodd" 
                d="M15.5501 3.70825H21.2143C21.9815 3.70825 22.7173 4.01115 23.2598 4.55032C23.8024 5.08949 24.1071 5.82075 24.1071 6.58325V18.0833C24.1071 18.8457 23.8024 19.577 23.2598 20.1162C22.7173 20.6554 21.9815 20.9583 21.2143 20.9583H18.4352C18.4171 20.9386 18.3985 20.9194 18.3793 20.9008C16.9329 19.4633 16.875 18.1695 16.875 14.7291C16.875 14.3478 16.7226 13.9822 16.4514 13.7126C16.1801 13.443 15.8122 13.2916 15.4286 13.2916H13.0236C13.0584 9.6595 13.3361 6.69634 15.5501 3.70825ZM12.123 3.70825H5.78571C5.01848 3.70825 4.28267 4.01115 3.74016 4.55032C3.19764 5.08949 2.89286 5.82075 2.89286 6.58325V18.0833C2.89286 18.8457 3.19764 19.577 3.74016 20.1162C4.28267 20.6554 5.01848 20.9583 5.78571 20.9583H14.877C14.1441 19.5016 14.0091 17.9414 13.986 16.1666H11.5714C11.1878 16.1666 10.8199 16.0151 10.5486 15.7456C10.2774 15.476 10.125 15.1103 10.125 14.7291V14.5949C10.125 10.9724 10.125 7.32884 12.123 3.70825ZM0 6.58325C0 5.05826 0.609565 3.59572 1.6946 2.51739C2.77963 1.43905 4.25125 0.833252 5.78571 0.833252H21.2143C22.7488 0.833252 24.2204 1.43905 25.3054 2.51739C26.3904 3.59572 27 5.05826 27 6.58325V18.0833C27 19.6082 26.3904 21.0708 25.3054 22.1491C24.2204 23.2275 22.7488 23.8333 21.2143 23.8333H5.78571C4.25125 23.8333 2.77963 23.2275 1.6946 22.1491C0.609565 21.0708 0 19.6082 0 18.0833V6.58325ZM17.8393 10.8958C17.8393 11.277 17.9917 11.6426 18.2629 11.9122C18.5342 12.1818 18.9021 12.3333 19.2857 12.3333C19.6693 12.3333 20.0372 12.1818 20.3085 11.9122C20.5798 11.6426 20.7321 11.277 20.7321 10.8958V8.97909C20.7321 8.59784 20.5798 8.2322 20.3085 7.96262C20.0372 7.69304 19.6693 7.54159 19.2857 7.54159C18.9021 7.54159 18.5342 7.69304 18.2629 7.96262C17.9917 8.2322 17.8393 8.59784 17.8393 8.97909V10.8958ZM7.23214 12.3333C6.84853 12.3333 6.48062 12.1818 6.20936 11.9122C5.93811 11.6426 5.78571 11.277 5.78571 10.8958V8.97909C5.78571 8.59784 5.93811 8.2322 6.20936 7.96262C6.48062 7.69304 6.84853 7.54159 7.23214 7.54159C7.61576 7.54159 7.98366 7.69304 8.25492 7.96262C8.52618 8.2322 8.67857 8.59784 8.67857 8.97909V10.8958C8.67857 11.277 8.52618 11.6426 8.25492 11.9122C7.98366 12.1818 7.61576 12.3333 7.23214 12.3333Z" 
                fill="currentColor"
              />
            </svg>

            <div class="btn__text">macOS</div>
          </a>
        </div>
        <div class="install-item__btns">
           <a
            href="https://avovpn.org/avovpn-v013.apk"
            target="_blank"
            rel="noopener noreferrer"
            class="btn btn_sm"
          >
            <svg
              width="24"
              height="28"
              viewBox="0 0 24 28"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              class="btn__icon"
            >
              <path
                d="M0 18.9259C0 23.9815 4.01852 28 9.07407 28C14.1296 28 18.1481 23.9815 18.1481 18.9259V13.7407H0V18.9259ZM14.3889 3.88889L17.1111 1.16667L16.0741 0.12963L13.0926 3.11111C11.9259 2.46296 10.5 2.07407 9.07407 2.07407C7.64815 2.07407 6.22222 2.46296 5.05556 2.98148L2.07407 0L1.03704 1.16667L3.75926 3.88889C1.42593 5.44444 0 8.16667 0 11.1481V12.4444H18.1481V11.1481C18.1481 8.16667 16.7222 5.44444 14.3889 3.88889ZM5.18518 9.85185C4.40741 9.85185 3.88889 9.33333 3.88889 8.55556C3.88889 7.77778 4.40741 7.25926 5.18518 7.25926C5.96296 7.25926 6.48148 7.77778 6.48148 8.55556C6.48148 9.33333 5.96296 9.85185 5.18518 9.85185ZM12.963 9.85185C12.1852 9.85185 11.6667 9.33333 11.6667 8.55556C11.6667 7.77778 12.1852 7.25926 12.963 7.25926C13.7407 7.25926 14.2593 7.77778 14.2593 8.55556C14.2593 9.33333 13.7407 9.85185 12.963 9.85185Z"
                fill="currentColor"
              />
            </svg>

            <div class="btn__text">APK file</div>
          </a>

        </div>
      </div>
      <div class="install-item install-item_4">
        <div class="install-item__num">4</div>
        <div
          class="install-item__text install-item__text_short"
          v-html="$t('main.install.text4')"
        />
      </div>

      <div class="install-video install-video_1">
        <div class="install-video__wrapper">
          <iframe width="560" height="315" src="https://www.youtube.com/embed/1tj1Gy_NxFI" title="video for iOS" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        </div>
        <div class="install-video__text">{{ $t('main.install.video_1_text') }}</div>
      </div>

      <div class="install-video install-video_2">
        <div class="install-video__wrapper">
          <iframe width="560" height="315" src="https://www.youtube.com/embed/h4gphk1l2Dw" title="video for Android" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        </div>
        <div class="install-video__text">{{ $t('main.install.video_2_text') }}</div>
      </div>

    </div>
  </section>
</template>

<script>
export default {
  name: 'InstallBlock'
}
</script>
